/**
 * Created by Ning Jiang on 2021-06-22.
 */

import {BitmapCountUp} from "@nolimitcity/slot-game/bin/component/BitmapCountUp";
import {gsap} from "gsap";
import {DDayGameAssets} from "../../../DDayGameAssets";
import {DDayLayers, Layers} from "../../../view/DDayLayers";
import {Impact} from "../../../Font/Impact";
import {Translation} from "../../../../core/utils/Translation";

export class BigWinCountUp extends PIXI.Container {

    protected _countUp: BitmapCountUp;
    private _endingScale: number = 1.3;
    protected _waysWonText: PIXI.Text;

    constructor() {
        super();

        const style = {
            fontName: DDayGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 40,
            tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
        };
        const waysWonStyle = new PIXI.TextStyle({
            fontFamily: Impact.FAMILY,
            fontSize: "60px",
            stroke: "#000000",
            strokeThickness: 10,
            fill: "#EFEBDE",
            dropShadowColor: "#000000",
            dropShadowAlpha: 0.95,
            dropShadowAngle: 90,
            dropShadowDistance: 17,
            lineJoin: "round"
        });
        this._countUp = new BitmapCountUp(style);
        this._countUp.shrinkSize = true;
        this._countUp.visible = false;
        this._countUp.position = new PIXI.Point(0, -80);
        this._waysWonText = new PIXI.Text("", waysWonStyle);
        this._waysWonText.anchor = new PIXI.Point(0.5, 0.5);
        this._waysWonText.visible = false;
        this._waysWonText.alpha = 0;
        this._waysWonText.position = new PIXI.Point(-4, 80);
        this.addChild(this._countUp, this._waysWonText);
        this.position.set(360, 600);
        DDayLayers.getLayer(Layers.WIN_COUNT_UP)?.addChild(this);
    }

    public getCountUpAnimation(from: number, to: number, duration: number): TimelineLite {
        const tl = gsap.timeline();
        this.position.set(360, 600);
        this._waysWonText.alpha = 0;
        this._waysWonText.visible = false;
        tl.add([
            () => {
                this._countUp.maxTextWidth = 580;
                this._countUp.scale.set(1);
                this._countUp.alpha = 1;
                this._countUp.visible = true;
            },
            this._countUp.getCountUpAnimation(from, to, duration, `power3.out`)
        ]);

        return tl;
    }

    public updateBigWinWays(waysCount: number): void {
        this._waysWonText.text = waysCount.toString() + " " + (waysCount === 1 ? Translation.translation("Way Won") : Translation.translation("Ways Won"));
        this._waysWonText.visible = true;
    }

    public stay(): TimelineLite {
        const tl = gsap.timeline();
        tl.add([
            gsap.to(this._countUp.scale, {
                duration: 0.5,
                x: this._endingScale,
                y: this._endingScale,
                ease: `elastic.out(1, 1)`
            }),
            gsap.to(this, {
                duration: 0.5,
                x: 360,
                y: 360,
                ease: `elastic.out(1, 1)`
            })
        ]);
        tl.to(this._waysWonText, {
            alpha: 1,
            duration: 0.1
        });
        // timeline.add(() => ElPasoGunfightSoundConfig.soundPlayer.playTrack({name : ElPasoGunfightSoundConfig.instance.COUNT_UP_END_FALL_BACK}), "-=0.3");
        return tl;
    }

    public remove(): TimelineLite {
        const tl = gsap.timeline();
        if (this._countUp.visible) {
            tl.add(gsap.to(this._countUp, {
                duration: 0.5,
                alpha: 0,
                y: -160,
                ease: `power2.in`
            }), "start"); // stay a short while after count up.
            tl.add(gsap.to(this._waysWonText, {
                duration: 0.5,
                alpha: 0,
                y: 0,
                ease: `power2.in`
            }), "start");
            tl.addLabel("start");
            tl.add(() => {
                this._countUp.y = -80;
                this._waysWonText.y = 80;
                this._countUp.visible = false;
                this._waysWonText.visible = false;
            });
        }
        return tl;
    }
}
